import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

import swal from 'sweetalert2';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoClienteGrupo } from '../../servicos/srv.cliente';

@Component({
  selector: 'tsv2-cligrp-listar',
  templateUrl: './listar.component.html',
  providers: [ ServicoMsg, ServicoClienteGrupo ]
})
export class ClienteGrupoListarComponent implements OnInit {
  @Input() items: any[];
  @Input() pagina: number;

  @Output() trocar = new EventEmitter();

  exibirBarra: boolean = true;

  constructor(
    private spinner: NgxSpinnerService,
    private servicoMsg: ServicoMsg,
    private servicoClienteGrupo: ServicoClienteGrupo
  ) {
    this.items = [];
    this.pagina = 1;
  }

  ngOnInit() {
  }

  removerClienteGrupo(id){
    let titulo = 'Remover o grupo de clientes?';
    let texto = 'Grupo de cliente removido com sucesso!';
    this.servicoMsg.exibeAlerta(titulo, id, this.servicoClienteGrupo, texto).then(r1 => {
      if (r1.success){
        this.trocar.emit(this.pagina);
      }
    }, (err: any) => {
      this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
